import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  accordionAnatomy.keys
);

const baseStylePanel = defineStyle({
  borderTopWidth: "",
  _last: {
    borderBottomWidth: "",
  },
});

const baseStyle = definePartsStyle({
  container: baseStylePanel,
});

export const accordionTheme = defineMultiStyleConfig({ baseStyle });
